import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";
import { useLanguage } from "../contexts/LanguageContext";
import { getConsent, setConsent } from "../lib/analytics";

const TEXT = {
  fr: {
    message: "Nous utilisons des cookies de mesure d'audience (Google Analytics) pour améliorer votre expérience. Vous pouvez accepter ou refuser à tout moment.",
    accept: "Accepter", reject: "Refuser", policy: "Politique de confidentialité",
  },
  en: {
    message: "We use audience-measurement cookies (Google Analytics) to improve your experience. You can accept or decline at any time.",
    accept: "Accept", reject: "Decline", policy: "Privacy Policy",
  },
};

export default function CookieConsent() {
  const { language } = useLanguage();
  const lang = language === "en" ? "en" : "fr";
  const t = TEXT[lang];
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[70] p-4 sm:p-5" data-testid="cookie-consent-banner">
      <div className="max-w-3xl mx-auto rounded-2xl border border-white/10 bg-zinc-950/95 backdrop-blur-xl shadow-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-6 h-6 text-indigo-400 shrink-0 hidden sm:block" />
        <p className="text-sm text-zinc-300 flex-1">
          {t.message}{" "}
          <Link to="/politique-de-confidentialite" className="text-indigo-400 hover:underline" data-testid="cookie-consent-policy-link">{t.policy}</Link>
        </p>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <Button variant="outline" className="border-white/15 flex-1 sm:flex-none" onClick={() => choose("rejected")} data-testid="cookie-consent-reject-btn">
            {t.reject}
          </Button>
          <Button
            className="text-white flex-1 sm:flex-none"
            style={{ background: "linear-gradient(135deg,#6366f1,#a855f7)" }}
            onClick={() => choose("accepted")}
            data-testid="cookie-consent-accept-btn"
          >
            {t.accept}
          </Button>
        </div>
      </div>
    </div>
  );
}
